import { Box } from "@mui/material";
import React from "react";
import { StriimTheme } from "@striim/striim-ui";
import TimeSeriesGraphWithStore from "src/generic/graphs/time-series-graph/time-series-graph-with-store";

/**
 * Preview pane for Foreseer CQ visualization
 * Gets data from Redux store instead of MobX
 */
// @ts-ignore
const PreviewPaneCQVisual = ({ height = 240, width = 1000 }) => {
    return (
        <StriimTheme>
            <Box padding={1}>
                <TimeSeriesGraphWithStore
                    height={height}
                    width={width}
                    series={[
                        {
                            color: "#8884d8",
                            dataKey: "predictedValue",
                            name: "Predicted Value"
                        },
                        {
                            color: "#82ca9d",
                            dataKey: "actualValue",
                            name: "Actual Value",
                            dot: function(val) {
                                if (val.payload.isAnomaly) {
                                    return <circle {...val} r={4} fill="red" />;
                                }
                                return <circle {...val} />;
                            }
                        },
                        {
                            color: "red",
                            dataKey: "anomaly",
                            name: "Anomaly"
                        }
                    ]}
                    title="Predicted vs Actual Value"
                />
            </Box>
        </StriimTheme>
    );
};

export default PreviewPaneCQVisual;
